import styled from "styled-components";

export const ContactContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;
  margin-top: 2rem;
  background-color: var(--secondary-background-color);

  @media (max-width: 426px) {
    flex-direction: column;   /* Stack items vertically */
    width: 95%;              /* Optional: make it fit smaller screens better */
    margin-bottom: 1.5rem;
  }
`;

export const ContactContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%;

  @media (max-width: 426px) {
    flex-direction: column;   /* Stack items vertically */
    width: 95%;              /* Optional: make it fit smaller screens better */
  }
`;

export const ContactLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
  margin-top: 5rem;

  @media (max-width: 426px) {
    margin-right: 0;    /* Remove side spacing */
    margin-top: 0;      /* Reduce spacing */
    margin-bottom: 2rem; /* Add spacing below text so it doesn’t touch the form */
    text-align: center;  /* Optional: center-align text on small screens */
  }
`;

export const ContactRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  form {
    display: flex;
    flex-direction: column;

    input, textarea {
      margin-bottom: 1rem;
      padding: 0.75rem;
      font-size: 1rem;
    }

    textarea {
      height: 10rem;
      resize: vertical;
    }

    button {
      padding: 0.75rem;
      cursor: pointer;
      background-color: var(--main-color);
      color: white;
      transition: all 0.2s ease-in-out;
        
      &:hover {
        background: var(--hover-color);
        color: white;
      }
    }
  }

  span {
    margin-top: 1rem;
    font-size: 0.9rem;
  }
`;

export const ContactHeader = styled.h1`
  color: var(--textColor);
  font-weight: bold;
  font-size: var(--headingSize);
  margin-bottom: 1rem;
  margin-left: 0;

  @media (max-width: 1024px) {
    font-size: var(--smallerHeaderSize);
  }
`;

export const ContactParagraph = styled.h4`
  color: var(--textColor);
  margin-left: 0;
  font-weight: normal;
  font-size: var(--subHeadingSize);

  @media (max-width: 1024px) {
    font-size: var(--smallerSubHeadingSize);
  }
`;